import { cartConstants, checkoutStatus } from "../action/Status";

const initState = {
    cartItems: [],
    updatingCart: false,
    updatingWishlist: false,
    error: null,
};

const cartReducer = (state = initState, action) => {
    switch (action.type) {
        case cartConstants.ADD_TO_CART_REQUEST:
            return {
                ...state,
                updatingCart: true,
            };

        case cartConstants.ADD_TO_CART_SUCCESS:
            return {
                ...state,
                cartItems: action.payload,
                updatingCart: false,
            };

        case checkoutStatus.CHECKOUT_SUCCESS:
            return {
                ...state,
            };

        case cartConstants.ADD_TO_CART_FAILURE:
            return {
                ...state,
                updatingCart: false,
                error: action.payload.error,
            };

        case cartConstants.ADD_TO_WISHLIST_SUCCESS:
            return {
                ...state,
                wishlistItems: action.payload.cartItems.product_id,
                updatingWishlist: false,
            };

        case "EMPTY_CART":
            return {
                ...initState,
            };

        case cartConstants.RESET_CART:
            return {
                ...initState,
            };

        default:
            return state;
    }
};

export default cartReducer;
